import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  useEffect(() => {
    // Automatically open mailto when component mounts
    window.location.href = 'mailto:contact@internhubapp.com?subject=Support Request from InternHub';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center items-center mb-4">
            <img
              src={process.env.PUBLIC_URL + '/maincar.png'}
              alt="InternHub Logo"
              className="h-12 mr-3"
            />
            <span className="text-blue-600 text-2xl font-bold">InternHub</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Contact Support</h1>
          <p className="text-gray-600">Get help with your InternHub experience</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-xs p-8 space-y-6">
          <div className="text-center">
            <div className="mb-6">
              <img
                src={process.env.PUBLIC_URL + '/badges/kitty_detective.png'}
                alt="Detective Kitty"
                className="w-24 h-24 mx-auto mb-4"
              />
            </div>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Opening your email client...
            </h2>

            <p className="text-gray-700 leading-relaxed mb-6">
              We've opened your default email client with our support email address. If it didn't
              open automatically, you can click the button below or manually send an email to:
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p className="text-blue-800 font-semibold text-lg">contact@internhubapp.com</p>
            </div>

            <div className="space-y-4">
              <a
                href="mailto:contact@internhubapp.com?subject=Support Request from InternHub"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                📧 Open Email Client
              </a>
            </div>

            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <h3 className="text-lg font-medium text-gray-800 mb-2">
                When contacting us, please include:
              </h3>
              <ul className="text-left text-gray-700 space-y-1">
                <li>• A detailed description of your issue</li>
                <li>• Steps to reproduce the problem (if applicable)</li>
                <li>• Your browser and operating system</li>
                <li>• Any error messages you're seeing</li>
              </ul>
            </div>
          </div>

          {/* Navigation */}
          <section className="border-t pt-6">
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0">
              <Link
                to="/home"
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                ← Back to Home
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Contact;
